<template>
    <AppHeaderDropdown>
        <template slot="header">
            <span class="active">{{ $t('reports.reports') }}</span>
        </template>
        <template slot="dropdown">
            <b-dropdown-item to="/v2/dashboard"> Dashboard </b-dropdown-item>
            <b-dropdown-item to="/v2/reports/objectives" v-if="showObjectivesReport">
                {{ $t('reports.objectives') }}
            </b-dropdown-item>
            <b-dropdown-item to="/v2/reports/tags" v-if="showTags"> Tags </b-dropdown-item>
            <b-dropdown-item to="/v2/insights" v-if="showInsights"> Insights </b-dropdown-item>
            <b-dropdown-item v-if="showNBoxReport" to="/v2/n-box/report"> N-Box </b-dropdown-item>
            <b-dropdown-item v-if="showReportsDropdownItem" to="/v2/reports" exact>
                {{ $t('reports.reports') }}
            </b-dropdown-item>
            <b-dropdown-item v-if="showEnpsDropdownItem" to="/v2/reports/enps"> eNPS </b-dropdown-item>
            <b-dropdown-item v-if="showMoodPulseDropdownItem" to="/v2/administrator/mood-pulse/report">
                {{ $t('moodPulse.moodPulse') }}
            </b-dropdown-item>
        </template>
    </AppHeaderDropdown>
</template>

<script>
import { HeaderDropdown as AppHeaderDropdown } from '@coreui/vue'

export default {
    name: 'DefaultReportsDropdown',
    props: {
        permissions: {
            type: Object,
            required: true,
        },
    },
    components: {
        AppHeaderDropdown,
    },
    computed: {
        showObjectivesReport() {
            return (
                this.companyHasModules(['okr']) &&
                this.permissions.hasOkr &&
                (this.permissions.isAdmin ||
                    this.permissions.isGod ||
                    this.permissions.isOkrLeader ||
                    this.permissions.isLocalAdministrator)
            )
        },
        showTags() {
            return (
                this.companyHasModules(['okr', 'goal']) &&
                (this.permissions.hasOkr || this.permissions.hasTarget) &&
                (this.permissions.isAdmin ||
                    this.permissions.isTargetMaster ||
                    this.permissions.isGod ||
                    this.permissions.isLocalAdministrator)
            )
        },
        showInsights() {
            return (
                this.companyHasModules(['okr']) &&
                this.permissions.hasOkr &&
                (this.permissions.isAdmin ||
                    this.permissions.isLocalAdministrator ||
                    this.permissions.isOkrLeader ||
                    this.permissions.isGod)
            )
        },
        showNBoxReport() {
            return (
                this.companyHasModules(['goal', 'value']) &&
                (this.permissions.hasTarget || this.permissions.hasValues) &&
                (this.permissions.isGod ||
                    this.permissions.isAdmin ||
                    this.permissions.isLocalAdministrator ||
                    this.permissions.isValuesMaster ||
                    this.permissions.isTargetMaster)
            )
        },
        showReportsDropdownItem() {
            return (
                this.companyHasModules(['goal', 'value']) &&
                (this.permissions.isGod ||
                    this.permissions.isAdmin ||
                    this.permissions.isLocalAdministrator ||
                    this.permissions.isValuesMaster) &&
                this.permissions.hasValues
            )
        },
        showEnpsDropdownItem() {
            return (
                this.companyHasModules(['enps']) &&
                (this.permissions.isGod ||
                    this.permissions.isAdmin ||
                    this.permissions.isLocalAdministrator ||
                    this.permissions.hasAdminAccess)
            )
        },
        showMoodPulseDropdownItem() {
            return (
                this.companyHasModules(['quiz']) &&
                (this.permissions.isGod ||
                    this.permissions.isAdmin ||
                    this.permissions.isLocalAdministrator ||
                    this.permissions.hasAdminAccess)
            )
        },
    },
    methods: {
        companyHasModules(modules) {
            return modules.some((module) => {
                return this.permissions.modules.includes('has_' + module)
            })
        },
    },
}
</script>
